import React, { useEffect, useState } from 'react'
import { useAddVideoMutation, useGetVideoByIdQuery, useUpdateVideoMutation } from '../features/video/videoApi'
import swal from 'sweetalert'
import { useDispatch, useSelector } from 'react-redux'
import { addVideoModal, updateVideoModal } from '../features/video/videoSlice'
import ModalHeader from './ModalHeader'
import moment from 'moment'

export default function VideoForm({ mode }) {
    const dispatch = useDispatch()
    const { videoId } = useSelector(state => state.video.modal) || {}
    const { isSuccess: isSuccessFetchVideo, data: video } = useGetVideoByIdQuery(videoId)
    const [addVideo, { isSuccess: isSuccessAddVideo }] = useAddVideoMutation()
    const [updateVideo, { isSuccess: isSuccessUpdateVideo }] = useUpdateVideoMutation()

    const [id, setId] = useState("")
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [url, setUrl] = useState("")
    const [duration, setDuration] = useState("")
    const [views, setViews] = useState("")

    useEffect(() => {
        if (mode !== "add" && videoId && isSuccessFetchVideo) {
            const { id, title, description, url, duration, views } = video[0] || {};

            setId(id)
            setTitle(title)
            setDescription(description)
            setUrl(url)
            setDuration(duration)
            setViews(views)
        }
    }, [mode, videoId, isSuccessFetchVideo, video])

    useEffect(() => {
        if (isSuccessAddVideo) {
            swal("Successful", "Video add successful", "success");
            resetForm()
            // close modal
            dispatch(addVideoModal({ type: "close" }))
            document.body.style.overflow = "auto"
        }
    }, [isSuccessAddVideo, dispatch])

    useEffect(() => {
        if (isSuccessUpdateVideo) {
            swal("Successful", "Video update successful", "success");
            // close modal
            dispatch(updateVideoModal({ type: "close" }))
            document.body.style.overflow = "auto"
        }
    }, [isSuccessUpdateVideo, dispatch])


    function handleAddVideo(e) {
        e.preventDefault();
        addVideo({ title, description, url, duration, views, createdAt: moment().format() })
    }

    function handleEditVideo(e) {
        e.preventDefault();
        updateVideo({ id, title, description, url, duration, views })
    }

    function resetForm() {
        setTitle("")
        setDescription("")
        setUrl("")
        setDuration("")
        setViews("")
    }

    function handleClose() {
        document.body.style.overflow = "auto"
        if (mode === "add") {
            // close add video modal
            dispatch(addVideoModal({ type: "close" }))
        }
        if (mode === "edit") {
            // close update video modal
            dispatch(updateVideoModal({ type: "close" }))
        }
    }

    return (
        <div className='w-3/4 md:w-2/4 mx-auto '>
            <div className='flex justify-between items-center mt-5'>
                <ModalHeader title={mode === "add" ? "Add New Video" : "Edit Video"} closeModal={handleClose} />
            </div>
            <form onSubmit={mode === "add" ? handleAddVideo : handleEditVideo} className='mt-5 p-5 bg-slate-800 rounded-lg'>
                <div className="mb-6">
                    <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Title</label>
                    <input type="text" id="title" name="title" value={title} onChange={e => setTitle(e.target.value)} className="border rounded-lg  block w-full p-2 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                </div>
                <div className="mb-6">
                    <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Description</label>
                    <textarea rows="5" type="text" id="description" name="description" value={description} onChange={e => setDescription(e.target.value)} className="border rounded-lg  block w-full p-2 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                </div>
                <div className="mb-6">
                    <label htmlFor="url" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Video url</label>
                    <input type="url" id="url" name="url" value={url} onChange={e => setUrl(e.target.value)} className="border rounded-lg  block w-full p-2 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                </div>
                <div className="mb-6">
                    <label htmlFor="duration" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Duration</label>
                    <input type="text" id="duration" name="duration" value={duration} onChange={e => setDuration(e.target.value)} className="border rounded-lg  block w-full p-2 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                </div>

                <div className="mb-6">
                    <label htmlFor="views" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Views</label>
                    <input type="text" id="views" name='views' value={views} onChange={e => setViews(e.target.value)} className="border rounded-lg  block w-full p-2 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                </div>
                <button type="submit" className="video-add-submit-btn text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-blue-600 hover:bg-blue-700 focus:ring-blue-800">{mode === "add" ? "Add" : "Update"} Video</button>
            </form>
        </div >
    )
}
